import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Icon.module.scss';
export function createIconComponent(SvgComponent) {
    const IconComponent = ({ ariaHidden, ariaLabel, className = '', color = null, dataTestId = null, onClick = () => null, size = 24, }) => (_jsx(SvgComponent, { onClick: onClick, height: size, width: size, className: `${styles.icon} ${className}`, style: color ? { fill: color } : undefined, "data-testid": dataTestId, "aria-label": ariaLabel, "aria-hidden": ariaHidden }));
    return IconComponent;
}
